module.exports = __webpack_public_path__ + "media/images/top_menu_icon/rooms_index-d9e4df974e6f26eb2a3b4d7db9f33ba1.png";